<section class="assign-teammate-wrapper flex flex-col">
  <div>
    <app-floating-input
      ngModel
      (ngModelChange)="searchTeammates($event)"
      [verticalSpacing]="false"
      [disabled]="isLoading()"
      iconClass="icon-search text-blue-700"
      placeholder="Search"
    ></app-floating-input>
  </div>
  <div class="flex-1 mt-2 min-h-0">
    @if (isLoading()) {
      <div class="relative w-full h-full">
        <app-loading-spinner class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></app-loading-spinner>
      </div>
    } @else if (displayedTeammates().length === 0) {
      <div class="no-results">
        <span>No results found.</span>
      </div>
    } @else {
      <ng-scrollbar appearance="native" class="std-scrollbar" orientation="vertical">
        @for (teammate of displayedTeammates(); track teammate.id) {
          <div (click)="onTeammateSelect(teammate)" class="teammate-row">
            <div class="profile-pic-container">
              @if (teammate.profile_picture_url) {
                <img class="profile-pic" [src]="teammate.profile_picture_url" alt="profile picture" />
              } @else {
                <span class="initials">{{ teammate.initials }}</span>
              }
            </div>
            <div class="font-semibold text-size_l">
              <span>{{ teammate.first_name + ' ' + teammate.last_name }}</span>
            </div>
            <div class="text-size_m">
              {{ teammate.home_base?.name ?? '' }}
            </div>
            <div class="text-size_m">
              {{ teammate.role }}
            </div>
          </div>
        }
      </ng-scrollbar>
    }
  </div>
</section>
